module.exports = __webpack_public_path__ + "img/dichiarazioni.a68c5f83.jpg";